export function currencyStringToNumber(currency: string) {
  // Replaces all non dot/digits and casts to Number
  return Number(currency.toString().replace(/[^0-9.-]+/g, ''));
}
